export const SAFE_ID_PATTERN = /^[A-Za-z0-9_-]{1,80}$/;
export function normalizeApiBaseUrl(value: string): string { return value.trim().replace(/\/+$/, ""); }
export function isHttpApiBaseUrl(value: string): boolean { try { const url=new URL(value); return url.protocol==="http:"||url.protocol==="https:" } catch { return false } }
